export { default as PhoneIcon } from './phone-icon.svg'
